import { combineReducers } from 'redux'

import statusReducer from './statusReducer'
import elasticIndicesReducer from './elasticIndicesReducer'
import elasticAliasesReducer from './elasticAliasesReducer'
import elasticTemplatesReducer from './elasticTemplatesReducer'
import reindexReducer from './reindexReducer'
import seleneReindexReducer from './seleneReindexReducer'
import elasticAggregatesReducer from './elasticAggregatesReducer'
import queueReducer from './queueReducer'
import configurationReducer from './configurationReducer'
import toasterReducer from './toasterReducer'
import exclusionsReducer from './exclusionsReducer'
import autoVersioningReducer from './autoVersioningReducer'

export default combineReducers({
  status: statusReducer,
  elasticAliases: elasticAliasesReducer,
  elasticIndices: elasticIndicesReducer,
  elasticTemplates: elasticTemplatesReducer,
  reindex: reindexReducer,
  seleneReindex: seleneReindexReducer,
  toaster: toasterReducer,
  exclusions: exclusionsReducer,
  elasticAggregates: elasticAggregatesReducer,
  queue: queueReducer,
  configuration: configurationReducer,
  autoVersioning: autoVersioningReducer,
})
